<template>
  <div v-if="isDisplayable" id="page" class="define-password">
    <div class="form-container">
      <b-container>
        <b-row>
          <b-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
            <div class="define-passwd-form">
              <b-row class="brand-section">
                <b-col cols="12" class="logo">
                  <img src="@/assets/img/bba/logo.png" alt="bba_logo" />
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" class="slogan text-center">
                  <h2>
                    {{ $t('bba.slogan') }}
                  </h2>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" class="def-pw-message">
                  <p class="padBottom-small">
                    {{ $t('define_password.phrase') }} {{ user.fullName }}
                  </p>
                </b-col>
              </b-row>

              <b-row class="justify-content-center">
                <b-col cols="10" md="8">
                  <text-input :label="formData.newPassword.label" name="neww-passwd"
                              v-model="formData.newPassword.value" type="password"
                  />
                </b-col>
              </b-row>

              <b-row class="justify-content-center">
                <b-col cols="10" md="8">
                  <text-input :label="formData.confirmNewPassword.label"
                              name="confirm-new-passwd"
                              v-model="formData.confirmNewPassword.value"
                              type="password"
                  />
                </b-col>
              </b-row>

              <b-row v-if="isSubmitted" class="justify-content-center">
                <b-alert v-if="displayErrors" variant="danger"
                         dismissible show class="col-10"
                >
                  <div v-for="error in errors" :key="error.id" class="error">
                    {{ error }}
                  </div>
                </b-alert>

                <b-alert v-if="displaySuccess" variant="success" show class="col-10">
                  {{ $t('define_password.alert.success')}}
                </b-alert>
              </b-row>

              <b-row>
                <b-col cols="12" class="text-center button-link">
                  <router-link v-if="displaySuccess" :to="{name: 'login'}"
                               class="orange-white btn"
                  >
                    {{ $t('login.form.submit') }}
                  </router-link>

                  <button v-else class="orange-white btn" @click="formSubmit">
                    {{$t('_validate')}}
                  </button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
  <div v-else class="define-password">
    <div class="form-container">
      <b-container>
        <b-row>
          <b-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
            <b-alert variant="danger" show class="col-10">
              <div class="error">
                {{ $t('define_password.invalid_token') }}
              </div>
            </b-alert>
            <router-link :to="{name: 'login'}" class="orange-white btn col-10">
              {{ $t('define_password.redirect_login') }}
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import FormSubmitter from '@/api/formSubmitter'
import textInput from '@/components/frontoffice/form/baseInput/text'

export default {
  components: {
    textInput
  },
  props : {
    isContingent: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      commonApi: new CommonApi(),
      formSubmitter: this.createFormSubmitter(),
      isDisplayable: false,
      user: {
        fullName: null,
        email: null
      },
      formData: {
        newPassword: {
          label: 'define_password.new_password',
          value: ''
        },
        confirmNewPassword: {
          label: 'define_password.confirm_new_password',
          value: ''
        }
      },
      errors: [],
      isSubmitted: false,
      displayErrors: false,
      displaySuccess: false
    }
  },

  created () {
    let promisedResponse
    if (this.isContingent === 1) {
      promisedResponse = this.commonApi.isDefinedContingentPasswordRouteDisplayable(this.$route.params.uid)
    } else {
      promisedResponse = this.commonApi.isDefinedPasswordRouteDisplayable(this.$route.params.uid)
    }
    promisedResponse
      .then(response => {
        if (response.data.success) {
          this.isDisplayable = true
          this.user = response.data.data.user
        }
      })
  },

  methods: {
    createFormSubmitter () {
      if (this.isContingent === 1) {
        return new FormSubmitter('change_hotel_password')
      } else {
        return new FormSubmitter('change_password')
      }
    },

    formSubmit () {
      this.isSubmitted = false
      this.errors = []
      this.formSubmitter.submitRequest(this.getData())
        .then(response => {
          if (response.data.success) {
            this.dealSuccess()
          } else {
            this.dealFailure(response.data.errors)
          }

          this.isSubmitted = true
        })
    },

    getData () {
      return {
        'email': this.user.email,
        'new': this.formData.newPassword.value,
        'new2': this.formData.confirmNewPassword.value
      }
    },

    dealSuccess () {
      this.commonApi.resetUserTempPasswordToken({ email: this.user.email })
      this.displayErrors = false
      this.displaySuccess = true
    },

    dealFailure (errors) {
      for (let i in errors) {
        if (errors.hasOwnProperty(i)) {
          this.errors.push(this.$i18n.t('error.' + errors[i]))
        }
      }

      this.displayErrors = true
      this.displaySuccess = false
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/login-account.scss';
</style>
